import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[appDomainValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DomainValidatorDirective,
      multi: true,
    },
  ],
  standalone: false,
})
export class DomainValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return domainValidator()(control);
  }
}

export function domainValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isProtocol = control.value.indexOf('http://') !== -1 || control.value.indexOf('https://') !== -1;
    let resValue = isProtocol ? control.value.slice(control.value.indexOf('//') + 2) : control.value;
    const idxPathSlash = resValue.indexOf('/');
    resValue =
      idxPathSlash !== -1 && resValue.slice(idxPathSlash).indexOf('.') === -1
        ? resValue.slice(0, idxPathSlash)
        : resValue;
    const pattern = /^([a-z\u00C0-\u00FF0-9]+(-[a-z\u00C0-\u00FF0-9]+)*\.)+[a-z]{2,}$/i;
    const result = pattern.test(
      Array.isArray(resValue) ? resValue[0].trim().toLowerCase() : resValue.trim().toLowerCase(),
    );
    return result ? null : { domain: { value: resValue } };
  };
}
